import React from "react";
import "./StatisticsSection.scss";

const statisticsData = [
  {
    number: "120m",
    title: "Cool feature title",
  },
  {
    number: "10.000",
    title: "Cool feature title",
  },
  {
    number: "240",
    title: "Cool feature title",
  },
];

const StatisticsSection = () => {
  return (
    <section className="statistics-section">
      <div className="statistics-section__header">
        <div className="statistics-section__subtitle">Our numbers</div>

        <h2 className="statistics-section__title">
          Handshake infographic mass market crowdfunding iteration.
        </h2>
      </div>

      <div className="statistics-section__content">
        {statisticsData.map((stat, index) => (
          <div key={index} className="statistics-section__stat-item">
            <div className="statistics-section__number">{stat.number}</div>

            <div className="statistics-section__stat-title">{stat.title}</div>
          </div>
        ))}
      </div>
    </section>
  );
};

export default StatisticsSection;
